var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Field, Form, Formik } from '@phishtool/ui';
import { enterpriseQuotePortalService } from '~service';
import { logEvent } from '@phishtool/analytics';
import { StyledFormWrapper } from './styled';
const AccessForm = ({ token, setQuotePortal }) => {
    const useMutationResult = enterpriseQuotePortalService.useGetQuotePortal({});
    const initialValues = {
        accessCode: '',
    };
    return (_jsx(StyledFormWrapper, { children: _jsx(Formik, { initialValues: initialValues, onSubmit: (values) => __awaiter(void 0, void 0, void 0, function* () {
                const quotePortal = yield useMutationResult.mutateAsync({
                    token,
                    accessCode: values.accessCode,
                });
                logEvent('Quote Portal Accessed', { portalId: quotePortal._id });
                setQuotePortal(Object.assign(Object.assign({}, quotePortal), { token, accessCode: values.accessCode }));
            }), children: (props) => (_jsx(Form, { submitText: "Submit", submitTheme: "upgrade", useMutationResult: useMutationResult, formikProps: props, children: _jsx(Field, { name: "accessCode", type: "code", validation: "isNonEmptyString", validationMessage: "Required", formikProps: props }) })) }) }));
};
export default AccessForm;
